import './Mask.less'
import Mask from './Mask'

export type { MaskProps } from './iMask'

export default Mask
